import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerService } from '../../services/customer/customer.service';
import { CustomerDTO } from 'src/app/domain/customer/customer.dto';
import { Customer } from '../../models/customer/customer.model';
import { CommonHelperService } from '../../utilities/common-helper/common-helper.service';
import { AppointmentDTO } from 'src/app/domain/customer/appointment.dto';
import { Appointment } from '../../models/customer/appointment.model';
import { AppointmentProfile } from '../../mappings/customer/appointment.mapping';
import { CustomerProfile } from '../../mappings/customer/customer.mappings';
import { CustomerInput } from '../../models/customer/customer-input';
import { CustomerDetails } from '../../models/customer/customer-details';
import { CustomerDetailsDTO } from 'src/app/domain/customer/customer-details.dto';
import { CustomerDetail } from '../../mappings/customer/customer-details.dto';

@Injectable({
  providedIn: 'root'
})
export class CustomerBusinessService {

  constructor(private customerService: CustomerService , private commonHelper: CommonHelperService) { }
  
  getCustomerListPagination(paramsReq: object): Observable<CustomerDTO>{
    return new Observable((observer) => {
      this.customerService.getCustomerListPagination(paramsReq).subscribe({
        next: (response:Customer) => {
          let result: CustomerDTO
          result = this.commonHelper.genericObjectMapper(response,CustomerProfile.DtoToDomain)
          observer.next(result);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    }
  )}

  getAppointmentListWithPagination(paramsReq: object):Observable<AppointmentDTO>{
    return new Observable((observer) => {
      this.customerService.getAppointmentListWithPagination(paramsReq).subscribe({
        next: (response:Appointment) => {
          let result: AppointmentDTO
          result = this.commonHelper.genericObjectMapper(response,AppointmentProfile.DtoToDomain)
          observer.next(result);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    }
  )}
 

  addCustomer(data: any): Observable<any> {
    return new Observable((observer) => {
      this.customerService.addCustomer(data).subscribe({
        next: (response) => {
          
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  updateCustomer(data:any):Observable<any>{
    return new Observable((observer)=>{
      this.customerService.UpdateCustomer(data).subscribe({
        next:(response)=>{
          try{
            observer.next(response)
          }
          catch(e){
            observer.error(e);
          }
        },error:(error)=>{
          observer.error(error);
        }
      })
    })
  }

  getCustomer(paramsReq:object):Observable<CustomerDetailsDTO>{
    return new Observable((observer)=>{
      this.customerService.getCustomerbyId(paramsReq).subscribe({
        next:(response:CustomerDetails) => {
          let result : CustomerDetailsDTO
          result = this.commonHelper.genericObjectMapper(response,CustomerDetail.DtoToDomain)
          observer.next(result);
        },
        error:((error)=>{
          observer.error(error);
        })
      })
    })
  }

  sendPosterToCus(data: any): Observable<any> {
    return new Observable((observer) => {
      this.customerService.sendPosterToCus(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }
}
